import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Switch from "@mui/material/Switch";
import "../../App.css";
import { BASE_URL, CHAT_IDS, TELEGRAM_API_TOKEN, Rigi_CHAT_IDS, Rigi_CHAT_NAME, getRkbAppToken } from "../../utils/config";
import IndexIntradaySection from "../../components/index-intradaySection";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Container from "react-bootstrap/Container";
import { styled } from "@mui/material/styles";
import Loading from "../../components/loading";
import Sidebar from "../../components/sidebar";
import Report from "../report";
import TelegramWidget from "../../components/widget/telegramWidget";
import IndexIntradayTable from '../../components/dashboard/indexIntradayTable';


const CreateIndexIntraDayReport = () => {
  const reportRef = useRef(null);
  const navigate = useNavigate();
  const [eventForm, setEventForm] = useState({
    eventType: "IndexIntraday",
  });
  const [tabs, setTabs] = useState([
    { id: 'IndexIntraday', label: 'IndexIntraday', data: [], previousClose: [], active: false },
  ]);
  const [indexIntradayRecord, setIndexIntradayRecord] = useState(0)
  const [selectedTabId, setSelectedTabId] = useState('IndexIntraday')
  const imageRef = useRef();
  const [imageName, setImageName] = useState(null);
  const [checked, setChecked] = useState(true);
  const [optionchecked, setOptionChecked] = useState(false);
  const [isFormEditable, setIsFormEditable] = useState(true);
  const [imageUrl, setimageURL] = useState(null);
  const [base64ImageData, setBase64ImageData] = useState("");
  const [reportDate, setReportDate] = useState({});
  const [loading, setLoading] = useState(false);
  const [indexIntradaySectionState, setIndexIntradaySectionState] = useState({
    optionReportType: "",
    stockType: "",
    optionCMP: "",
    optionSL: 0,
    strikePrice: "",
    stockIncToken: "",
    underlayingPrice: "",
    optionRemark: "",
    commentry: "",
    futureCMP: "",
    chartImageInterval: '1D',
    Expiry: "",
    Futureexpiry: '',
    volume: "",
    openInterest: "",
    lot_size: "",
  });
  const [IndexIntradayExpirySelected, setIndexIntradayExpirySelected] = useState([]);
  const [IndexIntradayStockSelected, setIndexIntradayStockSelected] = useState([]);
  const [secondtrgtchecked, setSecondTrgtChecked] = useState(false);
  const [freechecked, setFreechecked] = useState(false);
  const [stockLossRecord, setStockLossRecord] = useState({});
  const [stockSymbols, setStockSymbols] = useState([]);
  const [commenteryData, setCommenteryData] = useState([]);
  const [request_token, setRequestToken] = useState("");

  const [errorDialog, setErrorDialog] = useState(false);
  const [showErrorMsz, setShowErrorMsz] = useState(false);
  const [errorMessage, seterrorMessage] = useState('');
  const [telegrammezDialog, setTelegrammezDialog] = useState(false);
  const [activeBUY, setActiveBUY] = useState(false);
  const [activeSELL, setActiveSELL] = useState(false);
  const [futureError, setIndexIntradayError] = useState(false);
  const [SignalTypeSelect, setSignalTypeSelect] = useState(false);

  const [ApiError, setApiError] = useState(false);
  const [RoleType, setRoleType] = useState("");
  const [alreadySubmit, setAlreadySubmit] = useState(false);
  const [imageGenerate, setImageGenerate] = useState(false);

  let count = 0;
  let count1 = 0;

  useEffect(() => {
    const fetchDataInterval = setInterval(async () => {
      await fetchDataForAllTabs(selectedTabId);
      await fetchDataPreviousClose(selectedTabId);
    }, 60000);   //0,000 milliseconds = 1 minute

    if (count1 === 0) {
      fetchDataForAllTabs(selectedTabId);
      count1 += 1;
    }
    // Cleanup the interval on component unmount
    return () => clearInterval(fetchDataInterval);
  }, []);


  useEffect(() => {
    if (count === 0) {
      let roleType = JSON.parse(localStorage.getItem("roleType"));
      // console.log("roleType in side",roleType)
      setRoleType(roleType);
      if (roleType === "User") {
        setEventForm({ ...eventForm, eventType: "HNI" });
        getstock("HNI");
        getcommentery();
        count += 1;
      } else {
        getstock("IndexIntraday");
        getcommentery();
        count += 1;
      }
    }
  }, []);




  // this function is used fetch active record from DB
  const fetchDataForAllTabs = async (tabId) => {
    console.log("fetch record details for tabId:", tabId);
    try {
      let updatedTabs = [...tabs]; // Clone the tabs array to update its state
      let tab = updatedTabs.find(t => t.id === tabId); // Find the tab with the matching tabId

      if (!tab) {
        console.error('Tab not found:', tabId);
        return;
      }

      await fetch(`${BASE_URL}/getAllReportList/${tabId}`, {
        method: 'GET'
      })
        .then(response => response.json())
        .then(res => {
          // Process the API response data
          if (res.success === true) {
            console.log("index intraday res.data", res.data);

            if (tabId === 'IndexIntraday') {
              setIndexIntradayRecord(prevCount => prevCount + 1);
            }

            tab.data = res.data;

          } else {
            console.error('Error in response:', res);
            tab.data = []
            seterrorMessage(`Error: ${res.message}`)
            setShowErrorMsz(true)
            setErrorDialog(false)
            setTimeout(() => {
              setErrorDialog(false)
              seterrorMessage('')
              setShowErrorMsz(false)
            }, 2000);
          }
        })
        .catch(error => {
          // Handle errors
          console.error('Error fetching data:', error);
          seterrorMessage(`Error: ${error.message}`)
          setShowErrorMsz(true)
          setErrorDialog(false)
          setTimeout(() => {
            setErrorDialog(false)
            seterrorMessage('')
            setShowErrorMsz(false)
          }, 2000);
        });

      // Update the state with the new tabs array
      setTabs(updatedTabs);

      // Handle tab-specific logic


    } catch (error) {
      console.error('Error fetching data:', error);
      seterrorMessage(`Error: ${error.message}`)
      setShowErrorMsz(true)
      setErrorDialog(false)
      setTimeout(() => {
        setErrorDialog(false)
        seterrorMessage('')
        setShowErrorMsz(false)
      }, 2000);
    }
  };

  //  this function is used to fetch previous 7 day close signals
  const fetchDataPreviousClose = async (tabId) => {
    let loginuser = JSON.parse(localStorage.getItem("loginData"));
    console.log("Pevious fetch record details for tabId:", tabId);
    try {
      let updatedTabs = [...tabs]; // Clone the tabs array to update its state
      let tab = updatedTabs.find(t => t.id === tabId); // Find the tab with the matching tabId

      if (!tab) {
        console.error('Tab not found:', tabId);
        return;
      }

      await fetch(`${BASE_URL}/previousclose/${tabId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${loginuser.token}`
        }
      })
        .then(response => response.json())
        .then(res => {
          // Process the API response data
          if (res.success === true) {
            console.log("res.data previous Close", res.previousCloseData);


            if (tabId === 'screener') {
              setIndexIntradayRecord(prevCount => prevCount + 1);
            }

            tab.previousClose = res.previousCloseData;


          } else if (res.status === 403) {

            seterrorMessage(`Error: ${res.message}`)
            setShowErrorMsz(true)
            setErrorDialog(false)
            setTimeout(() => {
              setErrorDialog(false)
              seterrorMessage('')
              setShowErrorMsz(false)
              localStorage.clear()
              navigate('/login')
            }, 2000);
          }
          else if (res.status === 401) {

            seterrorMessage(`Error: ${res.message}`)
            setShowErrorMsz(true)
            setErrorDialog(false)
            setTimeout(() => {
              setErrorDialog(false)
              seterrorMessage('')
              setShowErrorMsz(false)
              localStorage.clear()
              navigate('/login')
            }, 2000);
          } else {
            console.error('Error in response:', res);
            seterrorMessage(`Error: ${res.message}`)
            setShowErrorMsz(true)
            setErrorDialog(false)
            setTimeout(() => {
              setErrorDialog(false)
              seterrorMessage('')
              setShowErrorMsz(false)
            }, 2000);
          }
        })
        .catch(error => {
          // Handle errors
          console.error('Error fetching data:', error);
          seterrorMessage(`Error: ${error.message}`)
          setShowErrorMsz(true)
          setErrorDialog(false)
          setTimeout(() => {
            setErrorDialog(false)
            seterrorMessage('')
            setShowErrorMsz(false)
          }, 2000);
        });

      // Update the state with the new tabs array
      setTabs(updatedTabs);

      // Handle tab-specific logic


    } catch (error) {
      console.error('Error fetching data:', error);
      seterrorMessage(`Error: ${error.message}`)
      setShowErrorMsz(true)
      setErrorDialog(false)
      setTimeout(() => {
        setErrorDialog(false)
        seterrorMessage('')
        setShowErrorMsz(false)
      }, 2000);
    }
  };


  // this function is used to change intraday section from child component
  const handleIndexIntradaySectionChange = (newIndexIntradayState) => {
    // console.log("future section change",newIndexIntradayState);
    setIndexIntradaySectionState(newIndexIntradayState);
  };

  // this function is used to change intraday expiry from child component
  const handleIndexIntradayExpirySelect = (newExpirySelected) => {
    setIndexIntradayExpirySelected(newExpirySelected);
  };

  // this function is used to change intraday stock  from child component
  const handleIndexIntradayStockSelect = (newStockSelected) => {
    // console.log("newStockSelected",newStockSelected)
    setIndexIntradayStockSelected(newStockSelected);
    setBase64ImageData("");
    setimageURL("");
    setImageGenerate(false);
  };


  //  this function is used to get all stock list to show in dropdown
  const getstock = async (reportType) => {
    try {
      setLoading(true)
      await fetch(`${BASE_URL}/getstocklist/${reportType}`, {
        method: "GET",
      })
        .then((response) => response.json())
        .then(async (res) => {

          if (res.success === true) {

            setStockSymbols(res.data);
            setRequestToken(res.request_token);

            setLoading(false)

          } else {
            setLoading(false);
            setErrorDialog(true);
            setApiError(true);

            setTimeout(() => {
              setErrorDialog(false);
              setApiError(false);
            }, 2000);
          }
        })
        .catch((error) => {
          // Handle errors
          setLoading(false);
          setErrorDialog(true);
          setApiError(true);

          setTimeout(() => {
            setErrorDialog(false);
            setApiError(false);
          }, 2000);
          console.error("Error fetching data:", error);
        });
    } catch (error) {
      setLoading(false);
      setErrorDialog(true);
      setApiError(true);

      setTimeout(() => {
        setErrorDialog(false);
        setApiError(false);
      }, 2000);
    }
  };

  //  this function is used to get all commentry data
  const getcommentery = async () => {
    try {
      var eventDate = new Date();
      var day = eventDate.getDate();
      var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var month = monthNames[eventDate.getMonth()];
      var year = eventDate.getFullYear();

      var formattedDate = day + " " + month + " " + year;
      // console.log("formattedDate", formattedDate);
      let loginuser = JSON.parse(localStorage.getItem("loginData"));

      setReportDate(formattedDate);
      await fetch(`${BASE_URL}/getallcommentery`, {
        method: "GET",
        headers: {
          'Authorization': `Bearer ${loginuser.token}`
        }
      })
        .then((response) => response.json())
        .then((res) => {
          // Process the API response data
          console.log(res.commenteryData);

          if (res.success === true) {
            setCommenteryData(res.commenteryData[0]);
          }
          else if (res.status === 403) {
            seterrorMessage(`Error: ${res.message}`)
            setShowErrorMsz(true)
            setErrorDialog(false)
            setTimeout(() => {
              setErrorDialog(false)
              seterrorMessage('')
              setShowErrorMsz(false)
              localStorage.clear()
              navigate('/login')
            }, 2000);
          }
          else if (res.status === 401) {

            seterrorMessage(`Error: ${res.message}`)
            setShowErrorMsz(true)
            setErrorDialog(false)
            setTimeout(() => {
              setErrorDialog(false)
              seterrorMessage('')
              setShowErrorMsz(false)
              localStorage.clear()
              navigate('/login')
            }, 2000);
          } else {
            seterrorMessage(`Error: ${res.message}`)
            setShowErrorMsz(true)
            setErrorDialog(false)
            setTimeout(() => {
              setErrorDialog(false)
              seterrorMessage('')
              setShowErrorMsz(false)
            }, 2000);
          }
        })
        .catch((error) => {
          // Handle errors
          console.error("Error fetching data:", error);
          seterrorMessage(`Error: ${error.message}`)
          setShowErrorMsz(true)
          setErrorDialog(false)
          setTimeout(() => {
            setErrorDialog(false)
            seterrorMessage('')
            setShowErrorMsz(false)
          }, 2000);
        });
    } catch (error) {
      seterrorMessage(`Error: ${error.message}`)
      setShowErrorMsz(true)
      setErrorDialog(false)
      setTimeout(() => {
        setErrorDialog(false)
        seterrorMessage('')
        setShowErrorMsz(false)
      }, 2000);
    }
  };


  // this fucntion is used to submit the report 
  const submitForm = async (event) => {
    event.preventDefault();
    setLoading(true);

    console.log("indexIntradaySectionState===========", indexIntradaySectionState);

    const cashCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
      indexIntradaySectionState.underlayingPrice
    );
    const futureCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
      indexIntradaySectionState.optionCMP
    );


    if (
      indexIntradaySectionState.underlayingPrice === "" ||
      indexIntradaySectionState.optionCMP === "" ||
      indexIntradaySectionState.futureCMP === "" ||
      indexIntradaySectionState.stockType === "" ||
      indexIntradaySectionState.Expiry === "" ||
      indexIntradaySectionState.commentry === "" ||
      indexIntradaySectionState.optionSL === ""
    ) {
      // console.log("inside if");
      setLoading(false);
      setErrorDialog(true);
      setIndexIntradayError(true);

      setTimeout(() => {
        setErrorDialog(false);
        setIndexIntradayError(false);
        // alert("Please Enter Valid Details.")
      }, 2000);
      // return;
    } else if (!cashCMPIsNumeric) {
      // Your code for the case when all are numeric
      // console.log("inside if cmp");
      setLoading(false);
      setErrorDialog(true);
      setIndexIntradayError(true);

      setTimeout(() => {
        setErrorDialog(false);
        setIndexIntradayError(false);
        // alert("Please Enter Valid Details.")
      }, 2000);
      // return; // Terminate the execution

      // generateReport(stock);
    } else if (!futureCMPIsNumeric) {
      // console.log("inside if future cmp");
      setLoading(false);
      setErrorDialog(true);
      setIndexIntradayError(true);

      setTimeout(() => {
        setErrorDialog(false);
        setIndexIntradayError(false);

        // alert("Please Enter Valid Details.")
      }, 2000);
      // return; // Terminate the execution
    }


    const { optionReportType, stockType, optionCMP, strikePrice, underlayingPrice, commentry, futureCMP, Expiry, lot_size,optionSL } = indexIntradaySectionState;
    const allValuesPresent = optionReportType && stockType && optionCMP && strikePrice && underlayingPrice && commentry && futureCMP && Expiry && lot_size && optionSL;

    if (allValuesPresent) {
      console.log("checked", checked);
      if (checked) {
        await sendTelegramMessage(indexIntradaySectionState);
      } else {
        const matchingStock = stockSymbols.find(
          (stock) => stock.name === indexIntradaySectionState.stockType
        );
        console.log("stock", matchingStock);
        generateReport(matchingStock.name, matchingStock.TVExchange);
      }

    } else {
      setErrorDialog(true);
      setSignalTypeSelect(true);
      setTimeout(() => {
        setErrorDialog(false);
        setSignalTypeSelect(false);
        setLoading(false);

        // alert("Please Enter Valid Details.")
      }, 2000);
    }

  };


  //  this function is used to send message in telegram 
  const sendTelegramMessage = async () => {
    try {
      console.log("indexIntradaySectionState.stockIncToken", indexIntradaySectionState.stockIncToken)
      if (!indexIntradaySectionState.stockIncToken) {

        seterrorMessage(`Error: Missing Required Field Instrument Token to Call Api.`)
        setShowErrorMsz(true)
        setErrorDialog(false)
        setTimeout(() => {
          setErrorDialog(false)
          seterrorMessage('')
          setShowErrorMsz(false)
        }, 2000);
        return
      }

      console.log('indexIntradaySectionState.stockType', indexIntradaySectionState.stockType);
      let lastPrice

      await fetch(`${BASE_URL}/getindexIntradaycmpprice/${indexIntradaySectionState.stockIncToken}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(response => response.json())
        .then(res => {
          console.log("inside indexindtrady latest price",)
          if (res.status === true) {
            console.log("Data", res.price);
            lastPrice = res.price
            setIndexIntradaySectionState((prevState) => ({
              ...prevState,  // Keep existing state
              optionCMP: lastPrice ?? prevState.optionCMP,  // Update lastPrice
            }));
          } else {
            seterrorMessage(`Error: ${res.message}`)
            setShowErrorMsz(true)
            setErrorDialog(false)
            setTimeout(() => {
              setErrorDialog(false)
              seterrorMessage('')
              setShowErrorMsz(false)
            }, 2000);
          }
        }).catch(error => {
          seterrorMessage(`Error: ${error.message}`)
          setShowErrorMsz(true)
          setErrorDialog(false)
          setTimeout(() => {
            setErrorDialog(false)
            seterrorMessage('')
            setShowErrorMsz(false)
          }, 2000);
        })

      const expiryDate = new Date(indexIntradaySectionState.Expiry);
      const futexpiryDate = new Date(indexIntradaySectionState.Futureexpiry);

      // Create an array of abbreviated month names in lowercase
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      // Get day, month, and year
      const day = expiryDate.getDate().toString().padStart(2, "0"); // ensures two digits
      const futday = futexpiryDate.getDate().toString().padStart(2, "0"); // ensures two digits

      const month = monthNames[expiryDate.getMonth()]; // getMonth() returns 0-indexed month
      const futmonth = monthNames[futexpiryDate.getMonth()]; // getMonth() returns 0-indexed month
      const year = expiryDate.getFullYear();
      const futyear = futexpiryDate.getFullYear();


      // Combine to get the formatted date
      const formattedDate = `${day}-${month}-${year}`;
      const futformattedDate = `${futday}-${futmonth}-${futyear}`;

      if (indexIntradaySectionState.optionReportType === 'BUY') {

        let activeData = tabs[0].data
        console.log("activeData BUY", activeData);

        let BUYfilteredData = []
        activeData.forEach(item => {
          if (item.SignalType === indexIntradaySectionState.stockType && item.SignalFinal === "BUY CALL Index/Intraday") {
            BUYfilteredData.push(item);
          }
        });


        console.log("ACTIVE BUY Filtered Data:", BUYfilteredData);

        if (BUYfilteredData.length > 0) {

          setErrorDialog(true);
          setActiveBUY(true)
          setShowErrorMsz(false)

          setTimeout(() => {
            setErrorDialog(false);
            setActiveBUY(false)
          }, 2000);
          setLoading(false);
          return
        }

        let filteredData = []
        activeData.forEach(item => {
          if (item.SignalType === indexIntradaySectionState.stockType && item.SignalFinal === "SELL PUT Index/Intraday") {
            filteredData.push(item);
          }
        });



        console.log("Filtered Data:", filteredData);
        // filter Active BUY record of Selected Stock

        if (filteredData.length > 0) {
          console.log("active SELL Record");

          let data = 'Dear Traders,';
          const message = `<b>${data}</b>
 
<b>${indexIntradaySectionState.stockType}</b> Index SELL Trade made a high of:
 
Cash CMP: ${filteredData[0].StockLow}
Future CMP: ${filteredData[0].FutureLow}
Option CMP: ${filteredData[0].OptionHigh}
`;

          // Option CMP: ${filteredData[0].OptionHigh}
          const rigimessage = `${data}

${indexIntradaySectionState.stockType} Index SELL Trade made a high of:

Cash CMP: ${filteredData[0].StockLow}
Future CMP: ${filteredData[0].FutureLow}
Option CMP: ${filteredData[0].OptionHigh}
`;

          // Option CMP: ${filteredData[0].OptionHigh}

          const RigichatId = Rigi_CHAT_IDS['IndexIntraday']
          const Rigichatname = Rigi_CHAT_NAME['IndexIntraday']
          const chatId = CHAT_IDS['IndexIntraday']

          const params2 = {
            content: rigimessage,
            attachments: "",
            type: "normal",
            notification_title: Rigichatname,
            description: rigimessage,
            soundName: "tone4",
            notificationToneName: "Tone4",
            groupId: RigichatId,
            textColor: "#ffd",
            sendToTelegram: 0,
            bgColor: "#000"
          };



          //  const body2 = JSON.stringify(params2);
          //  await fetch(`https://api.rakeshbansalventures.com/api/messages`, {
          //    method: 'POST',
          //    body: body2,
          //    headers: {
          //      'Content-Type': 'application/json',
          //      "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY5MzkzMzhjY2U5NGVmNzZmZjgwMWM2MCIsImVtYWlsIjoieWFzaEBhZG1pbi5jb20iLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE3NzI5OTc1NTQsImV4cCI6MTc3NTU4OTU1NH0.zn0folhP2J-0L1z8F9PbTX9E_qIktE-t32-5fBzsA9c"
          //    }
          //  });

          const messageResponse = await fetch(`https://api.telegram.org/bot${TELEGRAM_API_TOKEN}/sendMessage`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              chat_id: chatId,
              text: message,
              parse_mode: "HTML",
            }),
          });
          console.log("messageResponse", messageResponse);

        }



        let data = 'Index Trade';
        const message = `<b>${data}</b>

<b>${indexIntradaySectionState.optionReportType}</b> ${indexIntradaySectionState.stockType} 
CMP: ${lastPrice ? lastPrice : indexIntradaySectionState.optionCMP}
FutureCMP: ${indexIntradaySectionState.futureCMP}
FutureExpiry: ${futformattedDate}
OptionCMP: ${indexIntradaySectionState.underlayingPrice}
Strike Price: Buy ${indexIntradaySectionState.strikePrice} ${indexIntradaySectionState.optionReportType === 'BUY' ? 'CALL' : 'PUT'}
OptionExpiry: ${formattedDate}
OptionStopLoss:${indexIntradaySectionState.optionSL} 
${indexIntradaySectionState.optionRemark && indexIntradaySectionState.optionRemark.trim() ? `Remarks: ${indexIntradaySectionState.optionRemark}` : ''}`;

        // OptionCMP: ${indexIntradaySectionState.underlayingPrice}
        // Strike Price: Buy ${indexIntradaySectionState.strikePrice} ${indexIntradaySectionState.optionReportType === 'BUY' ? 'CALL' : 'PUT'}
        // OptionExpiry: ${formattedDate}
        const rigimessage = `${data}

${indexIntradaySectionState.optionReportType}: ${indexIntradaySectionState.stockType} 
CMP: ${lastPrice ? lastPrice : indexIntradaySectionState.optionCMP}
FutureCMP: ${indexIntradaySectionState.futureCMP}
FutureExpiry: ${futformattedDate}
OptionCMP: ${indexIntradaySectionState.underlayingPrice}
Strike Price: Buy ${indexIntradaySectionState.strikePrice} ${indexIntradaySectionState.optionReportType === 'BUY' ? 'CALL' : 'PUT'}
OptionExpiry: ${formattedDate}
OptionStopLoss:${indexIntradaySectionState.optionSL} 
${indexIntradaySectionState.optionRemark && indexIntradaySectionState.optionRemark.trim() ? `Remarks: ${indexIntradaySectionState.optionRemark}` : ''}`;


        // OptionCMP: ${indexIntradaySectionState.underlayingPrice}
        // Strike Price: Buy ${indexIntradaySectionState.strikePrice} ${indexIntradaySectionState.optionReportType === 'BUY' ? 'CALL' : 'PUT'}
        // OptionExpiry: ${formattedDate}
        const RigichatId = Rigi_CHAT_IDS['IndexIntraday']
        const Rigichatname = Rigi_CHAT_NAME['IndexIntraday']
        const chatId = CHAT_IDS['IndexIntraday']

        const params2 = {
          content: rigimessage,
          attachments: "",
          type: "normal",
          notification_title: Rigichatname,
          description: rigimessage,
          soundName: "tone4",
          notificationToneName: "Tone4",
          groupId: RigichatId,
          textColor: "#ffd",
          sendToTelegram: 0,
          bgColor: "#000"
        };

        const body2 = JSON.stringify(params2);

        const rkbAppToken = await getRkbAppToken();

        const rigiResponse = await fetch(`https://api.rakeshbansalventures.com/api/messages`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${rkbAppToken}`
          },
          body: body2,
        });

        const messageResponse = await fetch(`https://api.telegram.org/bot${TELEGRAM_API_TOKEN}/sendMessage`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            chat_id: chatId,
            text: message,
            parse_mode: "HTML",
          }),
        });
        console.log("messageResponse", messageResponse);





        // const slmessage = `Stoploss is 80 Points for future/index and 45 Points for option.`;



        // const slparams = {
        //   content: slmessage,
        //   attachments: "",
        //   type: "normal",
        //   notification_title: Rigichatname,
        //   description: slmessage,
        //   soundName: "tone4",
        //   notificationToneName: "Tone4",
        //   groupId: RigichatId,
        //   textColor: "#ffd",
        //   sendToTelegram: 0,
        //   bgColor: "#000"
        // };

        // const slbody = JSON.stringify(slparams);

        // const slrigiResponse = await fetch(`https://api.rakeshbansalventures.com/api/messages`, {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //     "Authorization": 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY5MzkzMzhjY2U5NGVmNzZmZjgwMWM2MCIsImVtYWlsIjoieWFzaEBhZG1pbi5jb20iLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE3NzI5OTc1NTQsImV4cCI6MTc3NTU4OTU1NH0.zn0folhP2J-0L1z8F9PbTX9E_qIktE-t32-5fBzsA9c'
        //   },
        //   body: slbody,
        // });


        // const slmessageResponse = await fetch(`https://api.telegram.org/bot${TELEGRAM_API_TOKEN}/sendMessage`, {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({
        //     chat_id: chatId,
        //     text: slmessage,
        //     parse_mode: "HTML",
        //   }),
        // });
        // console.log("slmessageResponse", slmessageResponse);

        if (messageResponse.ok === true) {
          setErrorDialog(true);
          setTelegrammezDialog(true)
          setShowErrorMsz(false)

          setTimeout(() => {
            setErrorDialog(false);
            setTelegrammezDialog(false)
          }, 2000);
          setAlreadySubmit(true);
          const matchingStock = stockSymbols.find(
            (stock) => stock.name === indexIntradaySectionState.stockType
          );
          console.log("stock", matchingStock);
          generateReport(matchingStock.name, matchingStock.TVExchange);
        } else {
          const errorMessage = await messageResponse.json();
          console.error("Error sending message to Telegram:", errorMessage);
          seterrorMessage(`Error: ${errorMessage}`)
          setShowErrorMsz(true)
          setErrorDialog(false)
          setTimeout(() => {
            setErrorDialog(false)
            seterrorMessage('')
            setShowErrorMsz(false)
          }, 2000);
        }


      } else if (indexIntradaySectionState.optionReportType === 'SELL') {

        let activeData = tabs[0].data
        console.log("activeData SELL", activeData);

        // filter Active SELL record of Selected Stock

        let SELLfilteredData = []

        activeData.forEach(item => {
          if (item.SignalType === indexIntradaySectionState.stockType && item.SignalFinal === "SELL PUT Index/Intraday") {
            SELLfilteredData.push(item);
          }
        });

        console.log("Active Sell Filtered Data:", SELLfilteredData);

        if (SELLfilteredData.length > 0) {
          setErrorDialog(true);
          setActiveSELL(true)
          setShowErrorMsz(false)

          setTimeout(() => {
            setErrorDialog(false);
            setActiveSELL(false)

          }, 2000);
          setLoading(false)
          return
        }



        // filter Active BUY record of Selected Stock
        let filteredData = []


        activeData.forEach(item => {
          if (item.SignalType === indexIntradaySectionState.stockType && item.SignalFinal === "BUY CALL Index/Intraday") {
            filteredData.push(item);
          }
        });
        console.log("Filtered Data:", filteredData);

        if (filteredData.length > 0) {
          console.log("active BUY Record");

          let data = 'Dear Traders';
          const message = `<b>${data}</b>
  
<b>${indexIntradaySectionState.stockType}</b> Index BUY Trade made a high of:
  
Cash CMP: ${filteredData[0].StockHigh}
Future CMP: ${filteredData[0].FutureHigh}
Option CMP: ${filteredData[0].OptionHigh}
  `;


          // Option CMP: ${filteredData[0].OptionHigh}
          const rigimessage = `${data}

${indexIntradaySectionState.stockType} Index BUY Trade made a high of:

Cash CMP: ${filteredData[0].StockHigh}
Future CMP: ${filteredData[0].FutureHigh}
Option CMP: ${filteredData[0].OptionHigh}
  `;

          // Option CMP: ${filteredData[0].OptionHigh}

          const RigichatId = Rigi_CHAT_IDS['IndexIntraday']
          const Rigichatname = Rigi_CHAT_NAME['IndexIntraday']
          const chatId = CHAT_IDS['IndexIntraday']

          const params2 = {
            content: rigimessage,
            attachments: "",
            type: "normal",
            notification_title: Rigichatname,
            description: rigimessage,
            soundName: "tone4",
            notificationToneName: "Tone4",
            groupId: RigichatId,
            textColor: "#ffd",
            sendToTelegram: 0,
            bgColor: "#000"
          };

          const body2 = JSON.stringify(params2);

          const rkbAppToken = await getRkbAppToken();

          const rigiResponse = await fetch(`https://api.rakeshbansalventures.com/api/messages`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              "Authorization": `Bearer ${rkbAppToken}`
            },
            body: body2,
          });


          const messageResponse = await fetch(`https://api.telegram.org/bot${TELEGRAM_API_TOKEN}/sendMessage`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              chat_id: chatId,
              text: message,
              parse_mode: "HTML",
            }),
          });
          console.log("messageResponse", messageResponse);


        }

        const RigichatId = Rigi_CHAT_IDS['IndexIntraday']
        const Rigichatname = Rigi_CHAT_NAME['IndexIntraday']
        const chatId = CHAT_IDS['IndexIntraday']

        let data = 'Index Trade';
        const message = `<b>${data}</b>

<b>${indexIntradaySectionState.optionReportType}</b>: ${indexIntradaySectionState.stockType} 
CMP: ${lastPrice ? lastPrice : indexIntradaySectionState.optionCMP}
FutureCMP: ${indexIntradaySectionState.futureCMP}
FutureExpiry: ${futformattedDate}
OptionCMP: ${indexIntradaySectionState.underlayingPrice}
Strike Price: Buy ${indexIntradaySectionState.strikePrice} ${indexIntradaySectionState.optionReportType === 'BUY' ? 'CALL' : 'PUT'}
OptionExpiry: ${formattedDate}
OptionStopLoss:${indexIntradaySectionState.optionSL} 
${indexIntradaySectionState.optionRemark && indexIntradaySectionState.optionRemark.trim() ? `Remarks: ${indexIntradaySectionState.optionRemark}` : ''}`;


        // OptionCMP: ${indexIntradaySectionState.underlayingPrice}
        // Strike Price: Buy ${indexIntradaySectionState.strikePrice} ${indexIntradaySectionState.optionReportType === 'BUY' ? 'CALL' : 'PUT'}
        // OptionExpiry: ${formattedDate}
        const rigimessage = `${data}

${indexIntradaySectionState.optionReportType}: ${indexIntradaySectionState.stockType} 
CMP: ${lastPrice ? lastPrice : indexIntradaySectionState.optionCMP}
FutureCMP: ${indexIntradaySectionState.futureCMP}
Futureexpiry: ${futformattedDate}
OptionCMP: ${indexIntradaySectionState.underlayingPrice}
Strike Price: Buy ${indexIntradaySectionState.strikePrice} ${indexIntradaySectionState.optionReportType === 'BUY' ? 'CALL' : 'PUT'}
OptionExpiry: ${formattedDate}
OptionStopLoss:${indexIntradaySectionState.optionSL} 
${indexIntradaySectionState.optionRemark && indexIntradaySectionState.optionRemark.trim() ? `Remarks: ${indexIntradaySectionState.optionRemark}` : ''}`;


        // OptionCMP: ${indexIntradaySectionState.underlayingPrice}
        // Strike Price: Buy ${indexIntradaySectionState.strikePrice} ${indexIntradaySectionState.optionReportType === 'BUY' ? 'CALL' : 'PUT'}
        // OptionExpiry: ${formattedDate}




        const params2 = {
          content: rigimessage,
          attachments: "",
          type: "normal",
          notification_title: Rigichatname,
          description: rigimessage,
          soundName: "tone4",
          notificationToneName: "Tone4",
          groupId: RigichatId,
          textColor: "#ffd",
          sendToTelegram: 0,
          bgColor: "#000"
        };

        const body2 = JSON.stringify(params2);

        const rkbAppToken = await getRkbAppToken();

        const rigiResponse = await fetch(`https://api.rakeshbansalventures.com/api/messages`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${rkbAppToken}`
          },
          body: body2,
        });

        const messageResponse = await fetch(`https://api.telegram.org/bot${TELEGRAM_API_TOKEN}/sendMessage`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            chat_id: chatId,
            text: message,
            parse_mode: "HTML",
          }),
        });
        console.log("messageResponse", messageResponse);
        // const slmessage = `Stoploss is 80 Points for future/index and 45 Points for option.`;
        // const slparams = {
        //   content: slmessage,
        //   attachments: "",
        //   type: "normal",
        //   notification_title: Rigichatname,
        //   description: slmessage,
        //   soundName: "tone4",
        //   notificationToneName: "Tone4",
        //   groupId: RigichatId,
        //   textColor: "#ffd",
        //   sendToTelegram: 0,
        //   bgColor: "#000"
        // };
        // const slbody = JSON.stringify(slparams);
        // const slrigiResponse = await fetch(`https://api.rakeshbansalventures.com/api/messages`, {
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/json',
        //     "Authorization": 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY5MzkzMzhjY2U5NGVmNzZmZjgwMWM2MCIsImVtYWlsIjoieWFzaEBhZG1pbi5jb20iLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE3NzI5OTc1NTQsImV4cCI6MTc3NTU4OTU1NH0.zn0folhP2J-0L1z8F9PbTX9E_qIktE-t32-5fBzsA9c'
        //   },
        //   body: body2,
        // });

        // const slmessageResponse = await fetch(`https://api.telegram.org/bot${TELEGRAM_API_TOKEN}/sendMessage`, {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({
        //     chat_id: chatId,
        //     text: slmessage,
        //     parse_mode: "HTML",
        //   }),
        // });
        // console.log("slmessageResponse", slmessageResponse);






        if (messageResponse.ok === true) {
          setErrorDialog(true);
          setTelegrammezDialog(true)
          setShowErrorMsz(false)

          setTimeout(() => {
            setErrorDialog(false);
            setTelegrammezDialog(false)
          }, 3000);
          setAlreadySubmit(true);
          const matchingStock = stockSymbols.find(
            (stock) => stock.name === indexIntradaySectionState.stockType
          );
          console.log("stock", matchingStock);
          generateReport(matchingStock.name, matchingStock.TVExchange);
        } else {
          const errorMessage = await messageResponse.json();
          seterrorMessage(`Error: ${errorMessage}`)
          setShowErrorMsz(true)
          setErrorDialog(false)
          setTimeout(() => {
            setErrorDialog(false)
            seterrorMessage('')
            setShowErrorMsz(false)
          }, 2000);
        }


      }
    } catch (error) {
      seterrorMessage(`Error: ${error.message}`)
      setShowErrorMsz(true)
      setErrorDialog(false)
      setTimeout(() => {
        setErrorDialog(false)
        seterrorMessage('')
        setShowErrorMsz(false)
      }, 2000);
    }
  }

  // this function is used to generate report
  const generateReport = async (stock, stockType) => {
    //  console.log("image file", imageUrl)
    try {
      if (!imageUrl) {
        console.log("imageGenerate", imageGenerate);
        if (!imageGenerate) {
          console.log("insdie if of generte report");
          let intervaltime = '1D';
          if (eventForm.eventType === "IndexIntraday") {
            intervaltime = indexIntradaySectionState.chartImageInterval
          }

          await fetch(`${BASE_URL}/getstockimage/${stock}/${stockType}/${intervaltime}`, {
            method: "GET", // or 'POST' or any other HTTP method
            headers: {
              Accept: "image/png",
            },
            responseType: "blob", // Set the responseType to 'blob'
          })
            .then((response) => response.arrayBuffer())
            .then((buffer) => {

              const blob = new Blob([buffer], { type: "image/png" });
              let imageurl = URL.createObjectURL(blob);
              setimageURL(imageurl);

              if (blob) {
                const uint8Array = new Uint8Array(buffer);
                const base64String = uint8Array.reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                );
                const ImageData = btoa(base64String);
                setBase64ImageData(ImageData);
                if (eventForm.eventType === "IndexIntraday") {
                  setLoading(false);

                  console.log("inside image event function")
                  setTimeout(() => {
                    if (reportRef.current) {
                      console.log("inside child ref function")
                      if (indexIntradaySectionState.optionReportType === 'BUY') {
                        reportRef.current.submitreport("IndexIntradayBUY");
                      } else {
                        reportRef.current.submitreport("IndexIntradaySELL");
                      }

                    }
                  }, 1000);

                }




              } else {
                seterrorMessage(`Error: Failed To Generate Image.`)
                setShowErrorMsz(true)
                setErrorDialog(false)
                setTimeout(() => {
                  setErrorDialog(false)
                  seterrorMessage('')
                  setShowErrorMsz(false)
                }, 2000);
              }
            })
            .catch((error) => {
              console.error("Error fetching image:", error)
              seterrorMessage(`Error: ${error.message}`)
              setShowErrorMsz(true)
              setErrorDialog(false)
              setTimeout(() => {
                setErrorDialog(false)
                seterrorMessage('')
                setShowErrorMsz(false)
              }, 2000);
            });
        }
      } else if (imageName) {
        console.log("insdie else to set image  of generte report");
        const base64ImageData = imageUrl.split(",")[1];
        // console.log("base 64 image data",base64ImageData);

        // const image = reader.result;
        console.log("image form reader when file selected");
        // setimageURL(image);
        setBase64ImageData(base64ImageData);
        setLoading(false);
        setTimeout(() => {
          if (reportRef.current) {
            console.log("inside child ref function")
            if (indexIntradaySectionState.optionReportType === 'BUY') {
              reportRef.current.submitreport("IndexIntradayBUY");
            } else {
              reportRef.current.submitreport("IndexIntradaySELL");
            }

          }
        }, 1000);
        // setTimeout(() => {
        //   setLoading(false);

        // }, 2000);
      } else {
        seterrorMessage(`Error: Failed To Generate Image.`)
        setShowErrorMsz(true)
        setErrorDialog(false)
        setTimeout(() => {
          setErrorDialog(false)
          seterrorMessage('')
          setShowErrorMsz(false)
        }, 2000);
      }
    } catch (error) {
      seterrorMessage(`Error: ${error.message}`)
      setShowErrorMsz(true)
      setErrorDialog(false)
      setTimeout(() => {
        setErrorDialog(false)
        seterrorMessage('')
        setShowErrorMsz(false)
      }, 2000);
    }
  };

  //  this fucntion is used to generate image in already not created on the stock name selection
  const generateImage = async (stock, stockType, intervaltime) => {
    try {
      setLoading(true);
      console.log("insdie if of generte report");


      await fetch(`${BASE_URL}/getstockimage/${stock}/${stockType}/${intervaltime}`, {
        method: "GET", // or 'POST' or any other HTTP method
        headers: {
          Accept: "image/png",
        },
        responseType: "blob", // Set the responseType to 'blob'
      })
        .then((response) => response.arrayBuffer())
        .then((buffer) => {
          // console.log("buffer", typeof buffer,buffer)

          const blob = new Blob([buffer], { type: "image/png" });
          let imageurl = URL.createObjectURL(blob);
          setimageURL(imageurl);
          setImageGenerate(true);

          if (blob) {
            const uint8Array = new Uint8Array(buffer);
            const base64String = uint8Array.reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            );
            const ImageData = btoa(base64String);

            setBase64ImageData(ImageData);

            if (eventForm.eventType === "IndexIntraday") {
              setLoading(false);

            }


          } else {
            seterrorMessage(`Error: Failed To Generate Image.`)
            setShowErrorMsz(true)
            setErrorDialog(false)
            setTimeout(() => {
              setErrorDialog(false)
              seterrorMessage('')
              setShowErrorMsz(false)
            }, 2000);
          }
        })
        .catch((error) => {
          console.error("Error fetching image:", error)
          seterrorMessage(`Error: ${error.message}`)
          setShowErrorMsz(true)
          setErrorDialog(false)
          setTimeout(() => {
            setErrorDialog(false)
            seterrorMessage('')
            setShowErrorMsz(false)
          }, 2000);
        });
    } catch (error) {
      seterrorMessage(`Error: ${error.message}`)
      setShowErrorMsz(true)
      setErrorDialog(false)
      setTimeout(() => {
        setErrorDialog(false)
        seterrorMessage('')
        setShowErrorMsz(false)
      }, 2000);
    }
  };


  //  this function is used to clear all filed when singal is send to telegram
  const handleEventChangeOfTelegram = (newvalue) => {
    console.log("inside handleEventChangeOfTelegram", newvalue);
    setLoading(true);
    setEventForm({ ...eventForm, eventType: "" });
    setIsFormEditable(true);
    setTimeout(() => {
      if (newvalue === "IndexIntraday") {
        setEventForm({ ...eventForm, eventType: newvalue });
        setIndexIntradaySectionState({
          optionReportType: "",
          stockType: "",
          optionCMP: "",
          optionSL: 0,
          strikePrice: "",
          stockIncToken: "",
          underlayingPrice: "",
          optionRemark: "",
          commentry: "",
          futureCMP: "",
          chartImageInterval: '1D',
          Expiry: "",
          volume: "",
          openInterest: "",
          lot_size: "",
        });


        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setChecked(true);

        setAlreadySubmit(false);
        fetchDataForAllTabs(selectedTabId);
        setLoading(false);
      }
    }, 200);
    // setLoading(true)
  };

  //  this fucntion handle change to toggle send message on telegram or not
  const handleChange = (event) => {
    event.preventDefault();

    setChecked(event.target.checked);
  };

  //  this fucntion handle change to toggle send message on telegram or not
  const handleOptionChange = (event) => {
    event.preventDefault();

    setOptionChecked(event.target.checked);
  };


  //  this function is used to  check second target
  const handleIntraDayChange = (event) => {
    event.preventDefault();
    console.log("event.target.checked", event.target.checked);
    setSecondTrgtChecked(event.target.checked);
  };
  //  this function is used to check free channel
  const handleFreeChange = (event) => {
    event.preventDefault();
    console.log("event.target.checked", event.target.checked);
    setFreechecked(event.target.checked);
  };


  //  this fucntion is used to remove image
  const handleImageCancel = () => {
    setImageName(null);
    setimageURL(null);
    setBase64ImageData("")
  };


  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#23499E",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #23499E",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));


  //  this fucntion is used to remove file from child component
  const handleRemoveFileFromChild = () => {
    setimageURL(null);
    setBase64ImageData("");
    setImageName(null);
  };

  //  this function is used to change stoploss record from child component
  const handleStockLossRecordChange = (newRecord) => {
    setStockLossRecord(newRecord);
  };

  //  this fucntion is used to paste image
  const handlePaste = (e) => {
    e.preventDefault();
    const items = e.clipboardData.items;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.type.indexOf("image") !== -1) {
        // e.preventDefault();
        const file = item.getAsFile();

        setImageName(file.name);
        const reader = new FileReader();
        reader.onloadend = () => {
          // Handle the base64-encoded image
          const base64Image = reader.result;
          // Send the base64-encoded image to the backend using FormData or perform other actions
          // console.log(base64Image);
          setimageURL(base64Image);
        };

        reader.readAsDataURL(file);
      }
    }
  };

  // this function is used to change image data if image paste
  const handleContentChange = () => {
    imageRef.current.contentEditable = true;
  };

  //  this function call from child compoent to set form editable
  const handleEditableIndexFromReport = () => {
    setIsFormEditable(true);
  };
  //  this function is used to call from child component to set form disable edit
  const handleEditableFromReport = () => {
    setIsFormEditable(false);
  };

  //  this function call form child component when SL change 
  const updateSLchangefunction = async (tabId) => {

    fetchDataForAllTabs(tabId);

  }

  return (

    <>
      <Sidebar />
      <div className="create-report">
        <Container fluid style={{ padding: "0 40px" }}>
          {loading ? (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}
            >
              <Loading />
            </div>
          ) : null}

          {tabs[0].data.length === 0 ? null :
            <IndexIntradayTable Record={tabs[0].data} heading={'IntraDay Tab'} RecordColor={indexIntradayRecord} PreviousClose={tabs[0].previousClose} updateSLchange={() => updateSLchangefunction(tabs[0].id)} tablename={'IndexIntradaySL'} />
          }

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h2 class="create-report-heading">Create Index/Intraday report</h2>
            <h2 class="Preview-report-heading">Preview Screen</h2>
          </div>
          <div id="divcontent" className="divcontent">


            <form id="eventForm" className="eventForm">
              <div className="options">
                <div className="CreateReport-intraday">

                  <label style={{ width: '25%' }} htmlFor="withCommentery">Commentary</label>

                  <IOSSwitch
                    sx={{ m: 1 }}
                    defaultChecked
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />

                  <label style={{ width: '25%' }} htmlFor="withCommentery">Send In Option</label>

                  <IOSSwitch
                    sx={{ m: 1 }}
                    defaultChecked
                    checked={optionchecked}
                    onChange={handleOptionChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <button
                    type="button"
                    onClick={submitForm}
                    className="submit-btn-index"
                  >Send Signal</button>


                  {eventForm.eventType === "IntraDay" ? (
                    <>
                      <>
                        <label style={{ width: '25%' }} htmlFor="intraDay">Second Target</label>

                        <IOSSwitch
                          sx={{ m: 1 }}
                          defaultChecked
                          checked={secondtrgtchecked}
                          onChange={handleIntraDayChange}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </>
                      <>
                        <label style={{ width: '10%' }} htmlFor="intraDay">Free</label>

                        <IOSSwitch
                          sx={{ m: 1 }}
                          defaultChecked
                          checked={freechecked}
                          onChange={handleFreeChange}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </>
                    </>
                  ) : null}



                </div>
              </div>


              <div className="form-report">
                {/* IndexIntraday Buying Section */}


                {stockSymbols.length > 0 && eventForm.eventType === "IndexIntraday" ? (
                  <div id="optionbuyingDiv" className="option">
                    <IndexIntradaySection
                      stockSymbols={stockSymbols}
                      IntraDaychecked={true}
                      SecondTarget={secondtrgtchecked}
                      requestToken={request_token}
                      commenteryData={commenteryData}
                      isEditable={isFormEditable}
                      onOptionSectionChange={handleIndexIntradaySectionChange}
                      onOptionExpirySelect={handleIndexIntradayExpirySelect}
                      onOptionStockSelect={handleIndexIntradayStockSelect}
                      onRemoveFile={handleRemoveFileFromChild}
                      onStockLossRecord={handleStockLossRecordChange}
                      generateImage={generateImage}
                      reportRef={reportRef}
                      handleEditableIndexFromReport={handleEditableIndexFromReport}
                    />
                  </div>
                ) : null}








                <div className="ReportImagePick" id="stockimageInputDiv">
                  <p>Image:</p>
                  <div
                    className="Image-paste-box"
                    ref={imageRef}
                    contentEditable={imageName}
                    onPaste={handlePaste}
                    onInput={handleContentChange}
                  >
                    {imageName ? (
                      <div>
                        <p style={{ width: "100%" }}>Image Name: {imageName}</p>
                        <i className="pi pi-times" style={{ margin: "auto", cursor: "pointer" }} onClick={handleImageCancel}></i>

                      </div>
                    ) : (
                      <p style={{ width: "100%" }}>Paste an image here...</p>
                    )}
                  </div>
                </div>


              </div>
            </form>

            <div className="preview-screen">
              {eventForm.eventType === "IndexIntraday" ? (
                <Report
                  ref={reportRef}
                  reportChecked={checked}
                  reportOptionChecked={optionchecked}
                  eventType={eventForm.eventType}
                  SectionState={indexIntradaySectionState}
                  reportDate={reportDate}
                  imageUrl={imageUrl}
                  imageBuffer={base64ImageData}
                  selectedExpiryRecord={IndexIntradayExpirySelected}
                  selectedStockRecord={IndexIntradayStockSelected}
                  setEventChange={handleEventChangeOfTelegram}
                  stockLossRecord={stockLossRecord}
                  onSuccessSubmit={handleEditableFromReport}
                  isMCX={true}
                />
              ) : null}






            </div>


            <TelegramWidget />
          </div>

          <Dialog
            open={errorDialog}
            onClose={() => {
              setErrorDialog(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <div>
                  {futureError ? (
                    <span style={{ color: "black" }}>
                      <span style={{ color: "red" }}>*</span> Please Fill All
                      Mendatory Field.
                    </span>
                  ) : null}

                  {ApiError ? (
                    <span style={{ color: "black" }}>
                      We're sorry, but something went wrong while processing
                      your request.
                    </span>
                  ) : null}
                  {telegrammezDialog ? (
                    <span style={{ color: "green" }}>
                      Message Send To Telegram Successfully.
                    </span>
                  ) : null}
                  {activeSELL ? (
                    <span style={{ color: "red" }}>
                      SELL signal is already active please close SELL signal or create BUY signal.
                    </span>
                  ) : null}
                  {activeBUY ? (
                    <span style={{ color: "red" }}>
                      BUY signal is already active please close BUY signal or create SELL signal.
                    </span>
                  ) : null}
                  {SignalTypeSelect ? (
                    <span style={{ color: "red" }}>
                      Please Select any Report Type BUY OR SELL.
                    </span>
                  ) : null}
                  {showErrorMsz ? (
                    <span style={{ color: "red" }}>
                      {errorMessage}
                    </span>
                  ) : null}
                </div>
              </DialogContentText>
            </DialogContent>
          </Dialog>



        </Container>
      </div>
    </>

  );
};

export default CreateIndexIntraDayReport;
